import { render } from "./EligibilityVerifiedPage.vue?vue&type=template&id=4afb9c1c"
import script from "./EligibilityVerifiedPage.vue?vue&type=script&lang=js"
export * from "./EligibilityVerifiedPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__